import {THEME} from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

export const WIDTH = 230;
export const NARROW_WIDTH = 32;

export const FloatingContainer = styled.div<{active: boolean}>`
  position: fixed;
  z-index: 3;
  background: ${THEME.bgSurfaceRaised};
  top: 90%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px;
  transition:
    visibility 0.5s,
    opacity 0.5s;
  border-radius: 5px;
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.1);
  gap: 8px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  ${props =>
    props.active
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}
`;
